import React from 'react';
import { join } from '../../../utils';
import { Box, Flex } from '../../Layout';
import { useIconClasses } from './useIconClasses';
import { useTheme } from '../../../theme';
/**
 * `Icon` composes the `Flex` component. It renders an `svg` element.
 *
 * @see https://fe-docs.int.getresponse.com/gr-ui-neo/index.html?path=/docs/icon
 */
export const Icon = React.forwardRef(({ children, className, label, isDisabled, viewBox = '0 0 24 24', width = '1.5rem', height = '1.5rem', size, tag = 'span', ...boxProps }, ref) => {
    const theme = useTheme();
    const isButtonIcon = label !== undefined || tag === 'button';
    const classes = useIconClasses({ theme, isDisabled, isButtonIcon });
    return (React.createElement(Flex, { alignItems: "center", justifyContent: "center", tag: isButtonIcon ? 'button' : 'span', type: isButtonIcon ? 'button' : undefined, className: join(className, classes.icon), inline: true, ref: ref, width: typeof width === 'number' ? `${width}rem` : width, height: typeof height === 'number' ? `${height}rem` : height, size: typeof size === 'number' ? `${size}rem` : size, margin: 0, boxShadow: "none", padding: 0, border: "none", ...boxProps },
        React.createElement(Box, { tag: "svg", viewBox: viewBox, role: isButtonIcon ? 'img' : undefined, "aria-label": isButtonIcon ? label : undefined, focusable: isButtonIcon, "aria-hidden": !isButtonIcon, fill: "none", stroke: "none", width: "100%", height: "100%", xmlns: "http://www.w3.org/2000/svg" },
            isButtonIcon && label ? React.createElement("title", { id: label }, label) : null,
            children)));
});
